<template>
  <nav
    class="navbar"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-menu">
      <div class="navbar-start">
        <div class="item title">{{ $t(page) }}</div>
        <div class="item search">
          <input
            class="search-input"
            type="text"
            :placeholder="$t('search')"
            @input="search"
            v-model="queryTerm"
          ><heim-icon-button @click.native="search"><heim-icon icon="search"></heim-icon></heim-icon-button>
          <span class="bar"></span>
        </div>
      </div>
      <div class="navbar-end"></div>
    </div>
  </nav>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon";
import HeimIconButton from "@/components/form/button/heim-icon-button";
export default {
  name: "heim-nav",
  components: {
    HeimIcon,
    HeimIconButton
  },
  props: {
    query: {
      type: String
    }
  },
  data() {
    return {
      queryTerm: ""
    };
  },
  computed: {
    page() {
      return this.$route.meta.name;
    }
  },
  methods: {
    search() {
      this.$store.dispatch("search", this.queryTerm);
    }
  }
};
</script>

<style scoped>
.navbar,
.navbar-start,
.navbar-end {
  display: flex;
  align-items: center;
}
.navbar-start {
  width: 100%;
}
.navbar {
  background-color: #ffffff;
  min-height: 3.25rem;
  position: relative;
  z-index: 30;
}
.navbar-start {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  margin-right: auto;
}
.navbar-end {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin-left: auto;
}
.item {
  padding-left: 1rem;
  flex: 1 1 auto;
  align-self: auto;
}

.item.search {
  position: relative;
  height: 3.25rem;
  width: 70%;
}
.search-input {
  font-size: 1em;
  padding: 0.3rem 3rem 0.3rem 0.8em;
  display: block;
  width: 100%;
  height: 100%;
  border: none;
  border-bottom: solid 1px lightgrey;
  transition: border-bottom 0.1s ease;
}
.icon-button {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 1em;
  right: 1em;
}

input:focus {
  outline: none;
  border-bottom: solid 2px var(--heim-secondary-color);
}
.title {
  font-weight: 600;
  font-size: 1.17em;
  width: 30%;
}

@media screen and (min-width: 460px) {
  .navbar-menu {
    display: flex;
    align-items: center;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }
}
</style>
